import * as d3 from 'd3'
import { colorScaleDivergence1 } from '@fortressiq/fiq-ds'

const d3color = d3.scaleOrdinal(colorScaleDivergence1)

// eslint-disable-next-line import/prefer-default-export
export const getColor = pathId => d3color(pathId % (colorScaleDivergence1.length - 1))
